<template>
  <div>
    <loader v-if="load"></loader>
    <d-container fluid>
      <d-row>
        <!-- Main Sidebar -->
        <main-sidebar :items="sidebarItems" />

        <d-col
          class="main-content offset-lg-2 offset-md-3 p-0"
          tag="main"
          lg="10"
          md="9"
          sm="12"
        >
          <!-- Main Navbar -->
          <main-navbar />

          <alert></alert>
          <!-- Content -->
          <router-view></router-view>

        </d-col>
      </d-row>
    </d-container>
  </div>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';

// Main layout components
import MainNavbar from '_common/layout/MainNavbar/MainNavbar.vue';
import MainSidebar from '_common/layout/MainSidebar/MainSidebar.vue';
import Alert from '_shared/Alert.vue';
import Loader from '_shared/Loader.vue';

export default {
  name: 'admin',
  components: {
    Alert,
    Loader,
    MainNavbar,
    MainSidebar,
  },
  data() {
    return {
      sidebarItems: getSidebarItems(),
    };
  },
  computed: {
    load() {
      const Loading = this.$store.state.toggle.progress;
      if (Loading) {
        return Loading;
      }
      return false;
    },
  },
};
</script>
